import * as React from 'react';
import {useContext} from 'react';
import {ServiceContext} from '../../../../components/Services';
import ManagementTable from '../../components/ManagementTable';
import LocationNameForm from '../../forms/LocationNameForm';

const LocationNames = () => {
  const services = useContext(ServiceContext);
  return (
    <ManagementTable
      title="Location Names"
      addTitle="Add New Name"
      editTitle="Edit Name"
      columns={[
        {title: 'Label', field: 'label'}
      ]}
      loadData={async (query) => services.locationName.getTableNames(query)}
      renderForm={(props, name, onSaved) => (
        <LocationNameForm
          {...props}
          name={name ?? {}}
          onSaved={onSaved}
        />
      )}
    />
  )
}

export default LocationNames;
